import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "./Logo";

const VERIFIED_KEY = "twr_age_verified";
const DENIED_KEY = "twr_age_denied";

export default function AgeGate({ children }) {
  const navigate = useNavigate();
  const [verified, setVerified] = useState(() => localStorage.getItem(VERIFIED_KEY) === "1");
  const denied = sessionStorage.getItem(DENIED_KEY) === "1";

  useEffect(() => {
    if (denied) {
      toast.error("You must be 21 or older to view this page.");
      navigate("/", { replace: true });
    }
  }, [denied, navigate]);

  if (denied) return null;
  if (verified) return children;

  const confirm = () => {
    localStorage.setItem(VERIFIED_KEY, "1");
    setVerified(true);
  };

  const deny = () => {
    sessionStorage.setItem(DENIED_KEY, "1");
    toast.error("You must be 21 or older to view this page.");
    navigate("/", { replace: true });
  };

  return (
    <section className="min-h-screen flex items-center justify-center px-6 bg-[#0A0A0A]" data-testid="age-gate">
      <div className="w-full max-w-md text-center">
        <div className="inline-block"><Logo variant="vertical" /></div>
        <div className="hairline my-10 max-w-[80px] mx-auto" />
        <p className="eyebrow">Age Verification</p>
        <h1 className="font-serif text-4xl sm:text-5xl mt-4 leading-tight">Are you 21 or older?</h1>
        <p className="text-[var(--twr-warm-white)]/60 text-sm mt-6 leading-relaxed">
          This area of The Win Room features cigars, tobacco, and spirits. By entering, you confirm
          that you are at least 21 years of age.
        </p>
        <div className="mt-10 flex flex-col gap-3">
          <button onClick={confirm} data-testid="age-gate-confirm-btn" className="btn-bronze w-full">
            I am 21 or older — Enter
          </button>
          <button onClick={deny} data-testid="age-gate-deny-btn" className="btn-ghost w-full">
            I am not 21
          </button>
        </div>
        <p className="text-[var(--twr-warm-white)]/35 text-[11px] mt-8 leading-relaxed">
          You only need to confirm once. We check ID at the door and on delivery.
        </p>
      </div>
    </section>
  );
}
